// extracted by mini-css-extract-plugin
export default {"modal":"HO-z","modalOverlay":"IO-z","outfitHeading":"JO-z"};